import { toast } from "react-toastify";
import { axiosInstanceAuth } from "../../Utils/AxiosInstance";
export const GetAllRoles = (data) => {
  return {
    type: "get_allrole",
    payload: data,
    loader: false,
  };
};
export function getallRoles() {
  return async (dispatch) => {
    try {
      const url = "Auth/GetCurrentUserInfo?Module=ERP";

      const result = await axiosInstanceAuth.get(url);

      if (result.data.IsSuccess === true) {
        dispatch(GetAllRoles(result.data));
      } else {
        toast.error(result.data.Message);
      }
    } catch (error) {
      toast.error("Something went wrong!");
    }
  };
}

export const GetAllRolesTable = (data) => {
  return {
    type: "get_allroletable",
    payload: data,
    loader: false,
  };
};
export function getallRolesTable() {
  return async (dispatch) => {
    try {
      const url = "Roles?Module=ERP";

      const result = await axiosInstanceAuth.get(url);

      if (result.data.IsSuccess === true) {
        dispatch(GetAllRolesTable(result.data));
      } else {
        toast.error(result.data.Message);
      }
    } catch (error) {
      toast.error("Something went wrong!");
    }
  };
}
